import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="visibility"
export default class VisibilityController extends Controller {
  static targets = ['item', 'empty']

  connect() {
    this.observer = new MutationObserver(() => { this.toggleEmptyMessage() })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggleEmptyMessage() {
    if (!this.hasEmptyTarget) return

    const itemCount = this.itemTargets.length
    this.emptyTarget.classList.toggle('d-none', itemCount > 0)
  }
}
